import React, { FC, useState } from 'react'
import styles from './index.module.scss'
import SizeModal, { Size } from './sizeModal'
import { useTranslation } from 'react-i18next'
export type ISize = Size

interface HeaderProps {
  onSizeChange(size: Size): void
  onImportTemplate(): void
  initialValues?: {
    size: Size
  }
}

const Header: FC<HeaderProps> = ({ onSizeChange, initialValues }) => {
  const [sizeVisible, setSizeVisible] = useState(false)
  const { t } = useTranslation()
  const onSizeCancel = () => {
    setSizeVisible(false)
  }
  const onSizeOK = (size: Size) => {
    onSizeChange(size)
    setSizeVisible(false)
  }

  const showSizeModal = () => {
    setSizeVisible(true)
  }

  return (
    <>
      <ul className={styles.wrapper}>
        <li onClick={showSizeModal}>{t('canvasSize')}</li>
      </ul>
      <SizeModal
        initialValues={initialValues?.size}
        visible={sizeVisible}
        onCancel={onSizeCancel}
        onOk={onSizeOK}
      />
    </>
  )
}

export default Header
